module.exports = __webpack_public_path__ + "static/media/collapseIcon.93752c96.svg";